import { stripHtml } from "@/lib/citationUtils";
import { looksLikeHtml } from "@/lib/gmailMime";
import type { WorkflowRun } from "@/types/workflowEngine";

export interface SpamClassification {
  spam: boolean;
  confidence?: number;
  reason?: string;
}

export interface WorkflowEmailPreview {
  subject: string;
  from: string;
  to?: string;
  date?: string;
  body: string;
}

export function findSpamClassification(run: WorkflowRun): SpamClassification | null {
  for (const output of Object.values(run.state.nodeOutputs)) {
    const parsed = output.parsed as Record<string, unknown> | undefined;
    if (parsed && typeof parsed.spam === "boolean") {
      return {
        spam: parsed.spam,
        confidence: typeof parsed.confidence === "number" ? parsed.confidence : output.confidence,
        reason: typeof parsed.reason === "string" ? parsed.reason : undefined,
      };
    }
  }
  return null;
}

export function getEmailPreviewFromRun(run: WorkflowRun): WorkflowEmailPreview {
  const v = run.state.variables;
  const rawBody = String(v.body ?? v.content ?? "");
  const body = looksLikeHtml(rawBody) ? stripHtml(rawBody) : rawBody;

  return {
    subject: String(v.subject ?? "(No subject)"),
    from: String(v.from ?? ""),
    to: v.to ? String(v.to) : undefined,
    date: v.date ? String(v.date) : undefined,
    body: body.trim() || "(No body)",
  };
}
